import {FC} from 'react'
import find from 'lodash/find'

type Props = {type: String}

const order = [
  {id: 'e_commerce', name: 'E-commerce', color: 'badge badge-light-secondary'},
  {id: 'wine_club', name: 'Wine club', color: 'badge badge-light-info'},
  {
    id: 'admin_portal',
    name: 'Manual Order',
    color: 'badge badge-light-primary',
  },
  {id: 'pos', name: 'POS', color: 'badge badge-light-dark'},
]

const OrderType: FC<Props> = ({type}: any) => {
  const obj = find(order, {id: type.toLowerCase()})
  return obj ? <span className={`badge ${obj.color}`}>{obj.name}</span> : type
}
export default OrderType
